import { IconItalic } from '@xingternal/icons';
import {
  toggleMark,
  isMarkActive,
  isBlockActive,
  ITALIC_DEFINITIONS,
} from '@xingternal/content-editor-plugin-helpers';

const buttonConfig = ({
  disabledForBlockTypes = [],
  icon = IconItalic,
  label = 'Italic',
  ...props
} = {}) => ({
  isHighlighted: (editor) => isMarkActive(editor, ITALIC_DEFINITIONS.type),
  isDisabled: (editor) =>
    disabledForBlockTypes.some((element) => isBlockActive(editor, element)),
  icon,
  label,
  onClick: (event, editor) => {
    event.preventDefault();
    toggleMark(editor, ITALIC_DEFINITIONS.type);
  },
  ...props,
});

export { buttonConfig };
